import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { DISPLAY_TIME_ZONE } from '../constants';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

const languageNames = new Intl.DisplayNames(['en'], { type: 'language' });
const countryNames = new Intl.DisplayNames(['en'], { type: 'region' });

export function formatLanguageName(code: string): string {
  return languageNames.of(code) ?? code;
}

export function formatCountryName(code: string): string {
  return countryNames.of(code) ?? code;
}

export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export function formatDate(
  isoString: string | null | undefined,
  style: 'long' | 'short' = 'long'
): string {
  if (!isoString) return '';
  return new Date(isoString).toLocaleDateString('en-US', {
    year: 'numeric',
    month: style,
    day: 'numeric',
    timeZone: DISPLAY_TIME_ZONE,
  });
}
